var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/SelectDependencies.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import React from 'react';
import { useStore } from 'effector-react';
import { combine, createEvent, createStore } from 'effector';
import { assertNever, isNotEmpty } from '@gmini/utils';
import { RoundedCross, Tabs } from '@gmini/ui-kit';
import { Dialog } from '@gmini/ui-kit/lib/Dialog';
import { getNode, node } from "../../classifier-service";
import { CloseButton, Header, Title, Separator, TabsWrapper, Content, DialogBody } from "./SelectDependencies.styled";
import { TabIndex } from "./tabIndex";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var openExplorer = createEvent({
  name: "openExplorer",
  sid: "cctv1g"
});
var closeExplorer = createEvent({
  name: "closeExplorer",
  sid: "v5fvjr"
});
var explorerOpened$ = createStore(false, {
  name: "explorerOpened$",
  sid: "-i8avbc"
}).on(openExplorer, function () {
  return true;
}).on(closeExplorer, function () {
  return false;
});
var emptyObj = {};
export function createSelectDependenciesParams(_ref) {
  var nodes$ = _ref.nodes$,
      currentEntity$ = _ref.currentEntity$;
  var addedDependencyIds$ = currentEntity$.map(function (classifier) {
    return (classifier === null || classifier === void 0 ? void 0 : classifier.sourceClassifiers.map(function (sourceClassifier) {
      return sourceClassifier.id;
    })) || null;
  });
  var currentModelsByClassifierMap$ = combine({
    ɔ: [{
      nodes: nodes$,
      currentEntity: currentEntity$
    }, function (_ref2) {
      var currentEntity = _ref2.currentEntity,
          nodes = _ref2.nodes;
      return (// const dependencies: node.BaseClassifierNode[] =
        (currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.sourceClassifiers.map(function (cls) {
          return getNode(nodes, cls);
        }).filter(isNotEmpty).filter(node.isBaseClassifierNode).map(function (baseClassifier) {
          var values = Object.values(nodes.ReferenceNode);
          var referenceNode = values.find(function (_ref3) {
            var parentClassifierId = _ref3.parentClassifierId,
                type = _ref3.type;
            return parentClassifierId === baseClassifier.id && type === 'BimModelReferenceNode';
          });

          if (!referenceNode) {
            return null;
          }

          var model = getNode(nodes, referenceNode.element);

          if (!model) {
            return null;
          }

          return {
            classifierId: baseClassifier.id,
            model: model
          };
        }).filter(isNotEmpty).reduce(function (acc, _ref4) {
          var classifierId = _ref4.classifierId,
              model = _ref4.model;
          acc[classifierId] = model;
          return acc;
        }, {})) || emptyObj
      );
    }],
    config: {
      name: "currentModelsByClassifierMap$",
      sid: "cdqr2k"
    }
  });
  return {
    currentModelsByClassifierMap$: currentModelsByClassifierMap$,
    addedDependencyIds$: addedDependencyIds$
  };
}
export var SelectDependencies = /*#__PURE__*/React.memo(function (_ref5) {
  var ModelsTree = _ref5.ModelsTree,
      ClassifiersTree = _ref5.ClassifiersTree,
      EstimationRepoTree = _ref5.EstimationRepoTree,
      brand = _ref5.brand;
  var open = useStore(explorerOpened$, {
    loc: {
      file: _effectorFileName,
      line: 112,
      column: 17
    },
    name: "SelectDependencies",
    sid: "SelectDependencies /src/classifier-editor/SelectDependencies/SelectDependencies.tsx [112, 17]"
  });

  var _React$useState = React.useState(TabIndex.ModelRepo),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tabIndex = _React$useState2[0],
      setTabIndex = _React$useState2[1];

  var onChangeTab = function onChangeTab(newValue) {
    setTabIndex(newValue);
  };

  var content = React.useMemo(function () {
    switch (tabIndex) {
      case TabIndex.ModelRepo:
        return /*#__PURE__*/_jsx(ModelsTree, {});

      case TabIndex.ClassifierRepo:
        return ClassifiersTree ? /*#__PURE__*/_jsx(ClassifiersTree, {}) : null;

      case TabIndex.EstimationRepo:
        return EstimationRepoTree ? /*#__PURE__*/_jsx(EstimationRepoTree, {}) : null;

      default:
        return assertNever('Unexpected tabIndex', tabIndex);
    }
  }, [ClassifiersTree, EstimationRepoTree, ModelsTree, tabIndex]);
  var tabs = [{
    title: 'Модели',
    content: null
  }];

  if (ClassifiersTree) {
    tabs.push({
      title: 'Классификаторы/сборки',
      content: null
    });
  }

  if (EstimationRepoTree) {
    tabs.push({
      title: 'Расчеты',
      content: null
    });
  }

  return /*#__PURE__*/_jsxs(Dialog, {
    onClose: closeExplorer,
    PaperComponent: DialogBody,
    open: open,
    fullWidth: true,
    maxWidth: "xl",
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438"
      }), brand && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Separator, {}), brand]
      }), /*#__PURE__*/_jsx(CloseButton, {
        "data-test-id": "closeDependencyList",
        "aria-label": "close",
        onClick: closeExplorer,
        type: "square",
        children: /*#__PURE__*/_jsx(RoundedCross, {
          color: "rgb(83, 95, 119)"
        })
      })]
    }), /*#__PURE__*/_jsx(TabsWrapper, {
      children: /*#__PURE__*/_jsx(Tabs, {
        onChangeTab: onChangeTab,
        activeTabIndex: tabIndex,
        headerStyles: {
          fontSize: '14px',
          height: '49px',
          gap: 40,
          marginTop: 'auto',
          marginBottom: '-1px',
          borderBottom: 'none'
        },
        contentStyles: {
          height: '100%',
          paddingTop: '0',
          display: 'flex'
        },
        tabs: tabs
      })
    }), /*#__PURE__*/_jsx(Content, {
      children: content
    })]
  });
});
SelectDependencies.displayName = 'SelectDependencies';